import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';

import { Spinner } from '@amzn/stencil-react-components/spinner';
import App from './components/App';
import AppInitWrapper from './components/AppInitWrapper';
import './monitoring';

import './index.scss';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <StrictMode>
    <AppInitWrapper>
      <Suspense fallback={<Spinner />}>
        <App />
      </Suspense>
    </AppInitWrapper>
  </StrictMode>,
);
